import { __decorate } from "tslib";
import { body } from "@pnp/odata";
import { _GraphQueryableCollection, _GraphQueryableInstance, graphInvokableFactory } from "../graphqueryable.js";
import { defaultPath, getById } from "../decorators.js";
import { graphDelete, graphPost } from "../operations.js";
/**
 * Member
 */
export class _Member extends _GraphQueryableInstance {
    /**
     * Removes this Member
     */
    remove() {
        return graphDelete(this.clone(Member, "$ref"));
    }
}
export const Member = graphInvokableFactory(_Member);
/**
 * Members
 */
let _Members = class _Members extends _GraphQueryableCollection {
    /**
     * Use this API to add a member to an Office 365 group, a security group or a mail-enabled security group through
     * the members navigation property. You can add users or other groups.
     * Important: You can add only users to Office 365 groups.
     *
     * @param id Full @odata.id of the directoryObject, user, or group object you want to add (ex: `https://graph.microsoft.com/v1.0/directoryObjects/${id}`)
     */
    add(id) {
        return graphPost(this.clone(Members, "$ref"), body({ "@odata.id": id }));
    }
};
_Members = __decorate([
    defaultPath("members"),
    getById(Member)
], _Members);
export { _Members };
export const Members = graphInvokableFactory(_Members);
//# sourceMappingURL=types.js.map